"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports.mapMetaTypeCodes = exports.invertSubTypes = exports.getSuburbs = void 0;
exports.unSlug = unSlug;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
/**
 * Attempts to make a slug more user friendly; information is lost when slugifying
 * something, e.g. casing and potentially characters are lost, so this cannot
 * totally reverse things.
 *
 * @param {String}  string        The string to unslug.
 * @param {Boolean} options.recase Whether to attempt to convert back to mixed
 *                  case; not possible to do this completely reliably.
 *
 * @return {String} The unslugged string.
 */
function unSlug(string, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$recase = _ref.recase,
    recase = _ref$recase === void 0 ? false : _ref$recase;
  if (!string) {
    return string;
  }
  var temp = string.replace(/-/g, ' ');
  if (!recase) return temp;
  return temp.replace(/\b[a-z]/g, function (letter) {
    return letter.toUpperCase();
  }).replace(/\bMc([a-z])/g, function (_, letter) {
    return "Mc" + letter.toUpperCase();
  });
}
var subTypeCodes = ['SAL', 'LSE', 'BOTH'];
var invertSubTypes = exports.invertSubTypes = function invertSubTypes(given) {
  return (0, _filter["default"])(subTypeCodes).call(subTypeCodes, function (x) {
    return (0, _indexOf["default"])(given).call(given, x) === -1;
  });
};

/**
 * Expand the given typeCode and subTypeCode options into a set of permitted
 * meta type code keys; meta type code keys may include both the typeCode and
 * subTypeCode.
 *
 * For example, with typeCode ['COM'] and subTypeCode of { not: ['LSE'] } we would
 * return { 'COMSAL': true, 'COMBOTH': true }.
 *
 * @param [ Array | string ] typeCode
 * @param Object subTypeCode
 */
var mapMetaTypeCodes = exports.mapMetaTypeCodes = function mapMetaTypeCodes(typeCode, subTypeCode) {
  if (typeCode === void 0) {
    typeCode = ['ALP', 'BUS', 'CLR', 'COM', 'HOL', 'LVS', 'LVW', 'REN', 'RUR', 'SAL'];
  }
  if (subTypeCode === void 0) {
    subTypeCode = {
      not: []
    };
  }
  var typeCodes = (0, _isArray["default"])(typeCode) ? typeCode : [typeCode];
  var _subTypeCodes = subTypeCode["in"] ? subTypeCode["in"] : invertSubTypes(subTypeCode.not);

  /* eslint-disable no-param-reassign */
  return (0, _reduce["default"])(typeCodes).call(typeCodes, function (res, code) {
    switch (code) {
      case 'COM':
        // Permit any that are somehow lacking a subTypeCode
        res[code] = true;
        (0, _forEach["default"])(_subTypeCodes).call(_subTypeCodes, function (subType) {
          res["" + code + subType] = true;
        });
        break;
      default:
        res[code] = true;
    }
    return res;
  }, {});
  /* eslint-enable no-param-reassign */
};
var notTotal = function notTotal(x) {
  return x !== 'total';
};

// typeCode => statusCode -> suburb -> postCode
var getSuburbs = exports.getSuburbs = function getSuburbs(types, statusCode, typeCode, subTypeCode) {
  var _context, _context2, _context3, _context11;
  if (!types) return [];
  var statusCodes = (0, _isArray["default"])(statusCode) ? statusCode : [statusCode];
  var statusMap = (0, _reduce["default"])(statusCodes).call(statusCodes, function (codes, status) {
    // eslint-disable-next-line no-param-reassign
    codes[status] = true;
    return codes;
  }, {});
  var typeMap = mapMetaTypeCodes(typeCode, subTypeCode);

  // Return true if statusCode was not provided by caller
  // Otherwise return whether or not statusCodes contains x
  function matchStatus(x) {
    return !statusCode || statusMap[x];
  }

  // Return true if typeCode was not provided by caller
  // Otherwise return whether or not typeCodes contains x
  function matchType(x) {
    return !typeCode || typeMap[x];
  }
  var keys = _keys["default"];
  var mapped = (0, _reduce["default"])(_context = (0, _filter["default"])(_context2 = (0, _filter["default"])(_context3 = keys(types)).call(_context3, notTotal)).call(_context2, matchType)).call(_context, function (typed, type) {
    var _context4, _context5, _context6;
    var statuses = types[type].statusCode;
    return (0, _reduce["default"])(_context4 = (0, _filter["default"])(_context5 = (0, _filter["default"])(_context6 = keys(statuses)).call(_context6, notTotal)).call(_context5, matchStatus)).call(_context4, function (statused, status) {
      var _context7, _context8;
      var suburbs = statuses[status].suburb;
      return (0, _reduce["default"])(_context7 = (0, _filter["default"])(_context8 = keys(suburbs)).call(_context8, notTotal)).call(_context7, function (suburbed, suburb) {
        var _context9, _context10;
        var postCodes = suburbs[suburb].postCode;
        return (0, _reduce["default"])(_context9 = (0, _filter["default"])(_context10 = keys(postCodes)).call(_context10, notTotal)).call(_context9, function (postcoded, postCode) {
          // eslint-disable-next-line no-param-reassign
          postcoded[unSlug(suburb.toLowerCase(), {
            recase: true
          }) + " " + postCode] = true;
          return postcoded;
        }, suburbed);
      }, statused);
    }, typed);
  }, {});
  return (0, _sort["default"])(_context11 = keys(mapped)).call(_context11);
};